<template>
  <div class="flex-direction">
    <div class="table-container-v3">
      <table class="table table-v3 is-fullwidth is-striped">
        <thead>
          <tr>
            <th class="-id-key">Identificador</th>
            <th class="-name-key">Nombre</th>
            <th>Correo</th>
            <th><center>Fecha de Registro</center></th>
          </tr>
        </thead>

        <tbody v-if="!isLoading">
          <tr v-for="broker in brokers" :key="broker.id">
            <td>
              <span class="-gray pointer">{{broker.id}}</span>
            </td>
            <td>
              <span class="-gray">{{broker.firstName}} {{broker.secondName}} {{broker.lastName}} {{broker.secondLastName}}</span>
            </td>
            <td>
                <span class="inactive-label -gray">{{broker.email}}</span>
            </td>
            <td>
              <center>
                <div class="inactive-label -gray">{{formatDate(broker.createdAt, 'DD-MMMM-YYYY', systemConfiguration.lang)}}</div>
              </center>
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr v-for="n in 8" :key="n">
            <td><div class="-loading-text -w30"></div></td>
            <td><div class="-loading-text -w80"></div></td>
            <td><div class="-loading-text -w70"></div></td>
            <td><div class="-loading-text -w60"></div></td>
          </tr>
        </tbody>

      </table>
      <div v-if="!isLoading && brokers.length == 0" class="-mb-4">
          <p class="-text3 -gray">Sin información</p>
      </div>
    </div>
    <div class="column is-12 has-text-centered">
      <Paginator :page="pagination.pageNumber" :pages="pagination.totalPages" :loading="isLoading" :action="getBrokers" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mixins from '@/mixins/formats'
export default {
  name: 'BrokersList',
  mixins: [mixins],
  components: {
    Paginator: () => import('@/components/ui/BasePagination.vue')
  },
  props: {
    brokers: {
      type: Array
    },
    pagination: {
      type: Object
    },
    getBrokers: {
      type: Function
    },
    isLoading: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration
    })
  }
}
</script>
